import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import PromoVideo from "../components/PromoVideo";
import Services from "../components/Services";
import HowItWorks from "../components/HowItWorks";
import Trust from "../components/Trust";
import Coverage from "../components/Coverage";
import About from "../components/About";
import AboutMe from "../components/AboutMe";
import Reviews from "../components/Reviews";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Social from "../components/Social";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import Chatbot from "../components/Chatbot";
import Seo from "../components/Seo";

export default function Home() {
  return (
    <>
      <Seo />
      <div className="grain-overlay min-h-screen bg-[var(--bg-main)] font-body text-slate-50">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <PromoVideo />
          <Services />
          <HowItWorks />
          <Trust />
          <Coverage />
          <About />
          <AboutMe />
          <Reviews />
          <FAQ />
          <Contact />
          <Social />
        </main>
        <Footer />
        <WhatsAppFloat />
        <Chatbot />
      </div>
    </>
  );
}
